export default __webpack_public_path__ + "static/media/noc.64fc5f13.png";